import { createSlice } from '@reduxjs/toolkit'
import Stripe from 'stripe'

import { RootState } from '../store'

interface FinancesState {
  connectAvailableBalance: Stripe.Balance['instant_available']
  connectAccountDetail: (Stripe.BankAccount | Stripe.Card)[]
  connectAllPayouts: Stripe.Payout[]
  payoutsTotal: number
}
const initialState: FinancesState = {
  connectAvailableBalance: [],
  connectAccountDetail: [],
  connectAllPayouts: [],
  payoutsTotal: 0,
}

const financesSlice = createSlice({
  name: 'finances',
  initialState,
  reducers: {
    setConnectAvailableBalance: (state, action) => ({
      ...state,
      connectAvailableBalance: action.payload,
    }),
    setConnectAccountDetail: (state, action) => ({
      ...state,
      connectAccountDetail: action.payload,
    }),
    setConnectAllPayouts: (state, action) => ({
      ...state,
      connectAllPayouts: action.payload,
    }),
    setPayoutsTotal: (state, action) => ({
      ...state,
      payoutsTotal: action.payload,
    }),
  },
})

export const {
  setConnectAvailableBalance,
  setConnectAccountDetail,
  setConnectAllPayouts,
  setPayoutsTotal,
} = financesSlice.actions

export const selectConnectAvailableBalance = (state: RootState) =>
  state.finances.connectAvailableBalance
export const selectConnectAccountDetail = (state: RootState) => state.finances.connectAccountDetail
export const selectConnectAllPayouts = (state: RootState) => state.finances.connectAllPayouts
export const selectPayoutsTotal = (state: RootState) => state.finances.payoutsTotal

export default financesSlice.reducer
